<template>
  <div class="article">
    <div class="article-hat">
      <div class="article-number">{{ article.number }}</div>
      <div class="article-title ellipsis" :title="article.title">{{ article.title }}</div>
    </div>
    <div class="article-coat" v-html="article.content" />
    <div class="form-actions" style="text-align: center; margin-bottom: 5px;">
      <a href="https://betstil.com/#/rules"><color-button color="yellow" style="margin-bottom: 10px;" @click="deposit">{{ $t('common.go-back') }}</color-button></a>
    </div>
  </div>
</template>>

<script>
import ColorButton from '@/components/buttons/ColorButton'
import { mapState } from 'vuex'

export default {
  components: {
    ColorButton
  },
  computed: {
    ...mapState({
      article: state => state.rules.article
    })
  }
}
</script>

<style scoped>
.article { background: rgba(255, 255, 255, .05); border-radius: 5px; margin: 10px; }
.article-hat { border-bottom: 1px solid #263238; display: flex; height: 40px; line-height: 40px; padding: 0 12px; }
.article-number { flex-shrink: 0; }
.article-title { flex: 1; margin-left: 10px; }
.article-coat { padding: 5px 10px; }
</style>

<style>
.article-coat a { color: #8c9eff; text-decoration: none; }
.article-coat a:hover { text-decoration: underline; }
.article-coat p { margin: 5px 0; }
.article-coat ul { margin: 5px 0 5px 14px; }
.article-coat table { margin: 5px 0; }

</style>



// WEBPACK FOOTER //
// src/components/rules/article/Article.vue